module.exports = __webpack_public_path__ + "static/media/logo.2b8ac9d3.png";